import type { LinkButton } from '../../button/LinkButton';
import type { ComponentProps, ReactNode } from 'react';

import { styled } from 'styled-components';

import innovatricsLogo from '../../../../assets/icons/inno-full-logo-white.svg';

import { NavLinks } from './NavLinks';

const HeaderSC = styled.header`
  height: ${(props) => props.theme.dimensions.navBarHeight};
  padding: 0 1rem;
  background-color: ${(props) => props.theme.colors.oxfordBlue[100]};
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${(props) => props.theme.colors.oxfordBlue[50]};
  font-size: 0.875rem;

  > img {
    margin-right: 1rem;
  }

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    padding: 0 3rem;
  }
`;

const LogoSC = styled.img`
  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    margin-right: 1.375rem;
  }

  height: 1.25rem;
`;

const FlexSC = styled.div`
  display: flex;
  align-items: center;
`;

const LogoLabelSC = styled.p`
  display: none;

  @media (min-width: ${(props) => props.theme.devices.tablet}) {
    display: block;
    max-width: 16rem;
  }

  @media (min-width: ${(props) => props.theme.devices.laptop}) {
    max-width: 100%;
  }
`;

type Link = {
  key: string;
  label: string;
  props: Omit<ComponentProps<typeof LinkButton>, 'children'>;
};

type DemoHeaderProps = {
  className?: string;
  'data-test-id'?: string;
  links?: Link[];
  logo?: ReactNode;
  title?: string;
};

export const DemoHeader = ({ links, logo, title, ...props }: DemoHeaderProps) => {
  return (
    <HeaderSC {...props}>
      <FlexSC>
        {!logo ? <LogoSC alt="Innovatrics logo" src={innovatricsLogo} /> : logo}
        <LogoLabelSC>{title}</LogoLabelSC>
      </FlexSC>
      {links && (
        <FlexSC>
          <NavLinks links={links} />
        </FlexSC>
      )}
    </HeaderSC>
  );
};
